const itemSchema = {
  title: 'Mention',
  addMessage: 'Ajouter une mention',
  fieldsets: [
    {
      id: 'default',
      title: 'Mention',
      fields: ['quote', 'source', 'year', 'url'],
    },
  ],
  properties: {
    quote: { title: 'Citation', type: 'string' },
    source: { title: 'Source', type: 'string' },
    year: { title: 'Année', type: 'string' },
    url: { title: 'Lien (optionnel)', type: 'string' },
  },
  required: ['quote', 'source'],
};

const schema = () => ({
  title: 'Presse & distinctions',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['eyebrow', 'heading', 'items'],
    },
  ],
  properties: {
    eyebrow: {
      title: 'Surtitre',
      type: 'string',
      default: 'Distinctions',
    },
    heading: {
      title: 'Titre',
      type: 'string',
      default: "Ce qu'on dit de nous.",
    },
    items: {
      title: 'Mentions',
      type: 'array',
      widget: 'object_list',
      schema: itemSchema,
    },
  },
  required: [],
});

export default schema;
